var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9202 20.2377C6.77099 20.6565 -0.0423308 10.2831 0.904285 5.22175C1.77282 3.7293 2.88609 2.62391 4.37604 1.75L7.61656 6.20123L5.97316 9.05534C5.97316 9.05534 6.42696 10.9607 8.13487 12.6686C9.92748 14.4612 11.9271 15.0093 11.9271 15.0093L14.7813 13.3659L19.392 16.7659C18.5342 18.2985 17.4528 19.3799 15.9202 20.2377Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.966c8e8240da4a0f5f7bb83d74eeb815.svg";
export { ForwardRef as ReactComponent };